import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  innerSidebarVisible: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    toggleInnerSidebar: (state) => {
      state.innerSidebarVisible = !state.innerSidebarVisible;
    },
    showInnerSidebar: (state) => {
      state.innerSidebarVisible = true;
    },
    hideInnerSidebar: (state) => {
      state.innerSidebarVisible = false;
    },
  },
});

export const { toggleInnerSidebar, showInnerSidebar, hideInnerSidebar } = uiSlice.actions;

export default uiSlice.reducer;

// Selectors
export const selectInnerSidebarVisible = (state) => state.ui.innerSidebarVisible;
